module.exports = __webpack_public_path__ + "media/images/posts/micro_weddings-7aae06dca9a7a5369445d88cf1c25ed4.jpg";